import { createSlice } from "@reduxjs/toolkit";
import { visaApplied, getVisaApplied, getVisaAppliedList, visaAppliedUpdateDeliveryDate } from "./VisaAppliedAction";

//for creating new Order
const visaAppliedSlice = createSlice({
  name: "VisaApplied",
  initialState: { visaAppliedLoading: false, visaAppliedError: false, visaAppliedSuccess: false, visaAppliedDetail: {}, visaAppliedList: [], visaAppliedListLoading: false, visaAppliedListError: false, visaAppliedUpdateLoading: false, visaAppliedUpdateError: false, visaAppliedUpdateSuccess: false },
  reducers: {
    clearError: (state) => {
      state.visaAppliedError = false;
    },
    clearSuccess: (state) => {
        state.visaAppliedSuccess = false;
    },
    clearLoading: (state) => {
        state.visaAppliedLoading = false;
    },
    clearVisaAppliedDetail: (state) =>{
        state.visaAppliedDetail = {}
    },
    clearVisaAppliedListLoading: (state) => {
      state.visaAppliedListLoading = false;
    },
    clearVisaAppliedListError: (state) => {
      state.visaAppliedListError = false;
    },
    clearVisaAppliedList: (state) => {
      state.visaAppliedList = [];
    },
    clearVisaAppliedUpdateLoading: (state) => {
      state.visaAppliedUpdateLoading = false;
    },
    clearVisaAppliedUpdateError: (state) => {
      state.visaAppliedUpdateError = false;
    },
    clearVisaAppliedUpdateSuccess: (state) => {
      state.visaAppliedUpdateSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(visaApplied.pending, (state) => {
        state.visaAppliedLoading = true;
      })
      .addCase(visaApplied.fulfilled, (state, action) => {
        state.visaAppliedDetail=action?.payload?.visaApplied;
        state.visaAppliedSuccess = true;
        state.visaAppliedLoading = false;
        state.visaAppliedError = false;
      })
      .addCase(visaApplied.rejected, (state, action) => {
        state.visaAppliedLoading = false;
        state.visaAppliedError = true;
      })
      .addCase(getVisaApplied.pending, (state) => {
        state.visaAppliedLoading = true;
      })
      .addCase(getVisaApplied.fulfilled, (state, action) => {
        state.visaAppliedDetail=action?.payload?.visaApplied;
        state.visaAppliedSuccess = true;
        state.visaAppliedLoading = false;
        state.visaAppliedError = false;
      })
      .addCase(getVisaApplied.rejected, (state, action) => {
        state.visaAppliedLoading = false;
        state.visaAppliedError = true;
      })
      .addCase(getVisaAppliedList.pending, (state) => {
        state.visaAppliedListLoading = true;
      })
      .addCase(getVisaAppliedList.fulfilled, (state, action) => {
        state.visaAppliedList = action?.payload?.visaAppliedList;
        state.visaAppliedListLoading = false;
        state.visaAppliedListError = false;
      })
      .addCase(getVisaAppliedList.rejected, (state, action) => {
        state.visaAppliedListLoading = false;
        state.visaAppliedListError = true;
      })
      .addCase(visaAppliedUpdateDeliveryDate.pending, (state) => {
        state.visaAppliedUpdateLoading = true;
      })
      .addCase(visaAppliedUpdateDeliveryDate.fulfilled, (state, action) => {
        state.visaAppliedUpdateSuccess = true;
        state.visaAppliedUpdateLoading = false;
        state.visaAppliedUpdateError = false;
      })
      .addCase(visaAppliedUpdateDeliveryDate.rejected, (state, action) => {
        state.visaAppliedUpdateLoading = false;
        state.visaAppliedUpdateError = true;
      });
  },
});

const visaAppliedAction = visaAppliedSlice.actions;

export { visaAppliedAction, visaAppliedSlice };
